<div
  class="dropzone text-center p-2"
  [class.has-files]="fileList?.length"
  (drop)="fileDropped($event)"
  (dragover)="preventDragOver($event)"
>
  <div class="dropzone-selector">
    <span>
      Drag and drop or
      <span class="pl-link" (click)="openFileExplorer()"
        >click to browse files
      </span>
    </span>

    <button
      mat-fab
      class="big-btn ml-3"
      color="accent"
      (click)="openFileExplorer()"
    >
      <mat-icon *ngIf="!loading; else loadingSpinner"> upload </mat-icon>
      <ng-template #loadingSpinner>
        <mat-progress-spinner mode="indeterminate" [diameter]="36">
        </mat-progress-spinner>
      </ng-template>
    </button>
    <input
      #fileInputEleRef
      hidden
      type="file"
      [accept]="accept"
      [multiple]="false"
      (change)="filesSelected($event)"
    />
  </div>
  <div *ngIf="fileList?.length" class="file-list mt-4">
    <div *ngFor="let file of fileList" class="file-list-item">
      <div class="file-list-item-name">
        <mat-icon class="ml-md-2 mr-md-2"> description </mat-icon>
        {{ file }}
      </div>
      <button mat-icon-button class="ml-md-3" (click)="clearFiles()">
        <mat-icon> delete </mat-icon>
      </button>
    </div>
  </div>
</div>
